export default {
  SET_DATA (state, data) {
    state.provinsi = data
  },
  SET_DATA_KOTA (state, data) {
    state.kota = data
  },
  SET_DATA_KECAMATAN (state, data) {
    state.kecamatan = data
  },
  SET_DATA_SEARCH (state, data) {
    state.search = data
  }
}